export const MAX_TEMPLATES_COUNT = 50;
